<app-files-manager [folderId]="folderId"></app-files-manager>
